import { Leaf } from "lucide-react";

const ITEMS = [
  "Body · Mind · Spirit",
  "Holistic Wellness",
  "Conscious Living",
  "Spiritual Education",
  "Iridology",
  "Support for Mothers",
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-xl italic text-ivory/85 sm:text-2xl">
          {item}
        </span>
        <Leaf className="h-4 w-4 shrink-0 text-gold" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-forest/20 bg-forest py-5">
    <div className="marquee-track flex w-max">
      <Row hidden={false} />
      <Row hidden />
    </div>
  </div>
);
